export const INIT = 'init' // 初始狀態
export const COMING = 'coming' // 尚未開始
export const ONGOING = 'ongoing' // 進行中
